import { ISchedule } from '../schedule';
import { ISession, SingleCommunication } from '../session';

export enum RxNames {
  CODEINE = 'codeine',
  FENTANYL = 'fentanyl',
  HYDROCODONE = 'hydrocodone',
  HYRDOMORPHONE = 'hyromorphone',
  MORPHINE = 'morphine',
  OXYCODONE = 'oxycodone',
  OXYMORPHONE = 'oxymorphone',
  METHADONE = 'methadone'
}

export const Modules = {
  pmt: 'Pain & Med',
  pdi: 'PDI',
  substance: 'Substance',
  mood: 'PHQ2'
};

export const PainOptions = {
  [1]: 'Alcohol',
  [2]: 'Distraction',
  [3]: 'Exercise',
  [4]: 'Medication',
  [5]: 'Other Drugs',
  [6]: 'Rest'
};

export interface IEpxOpioidMgmtSchedule extends ISchedule {
  modules?: any;
  prescriptionName?: RxNames;
  pillsPerDose?: number;
  dosesPerDay?: number;
  mgPerPill?: number;
  tapering?: any;
}

export interface IEpxOpioidMgmt extends ISession, SingleCommunication {
  module?: string;
  moduleSession?: number;
  _mood?: IEpxOpioidMgmtMood;
  _substance?: IEpxOpioidMgmtSubstance;
  _pmt?: IEpxOpioidMgmtPMT;
  _pdi?: IEpxOpioidMgmtPDI;
  _thresholds?: {
    pillsPerDose?: number;
    dosesPerDay?: number;
    mgPerPill?: number;
  };
}

export interface IEpxOpioidMgmtMood extends ISession {
  moodRating?: number;
  recentInterest?: number;
  recentDepressed?: number;
}

export interface IEpxOpioidMgmtSubstance extends ISession {
  hasUsed?: boolean;
  daysSinceUse?: number;
  urgeToUseRating?: number;
}

export interface IEpxOpioidMgmtPMT extends ISession {
  ratePain?: number;
  numberPills?: number;
  aboveThreshold?: boolean;
  painOptions?: number[];
}

export interface IEpxOpioidMgmtPDI extends ISession {
  home?: number;
  hobbies?: number;
  social?: number;
  work?: number;
  sex?: number;
  selfCare?: number;
  basicLife?: number;
}
